import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "s10_mobile" }
const _hoisted_3 = { class: "secondary-font text-grey-800 mb-4" }
const _hoisted_4 = { class: "s5" }
const _hoisted_5 = { href: "" }
const _hoisted_6 = { class: "img-area rounded-15 mb-0 px-3 py-2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "s14" }
const _hoisted_9 = { href: "" }
const _hoisted_10 = { class: "title secondary-font text-grey-600 mb-3" }
const _hoisted_11 = { class: "secondary-font font-bold mb-3" }
const _hoisted_12 = { class: "secondary-font mb-3" }
const _hoisted_13 = { class: "secondary-font mb-4 text-grey-700" }
const _hoisted_14 = { class: "mb-6 vertical" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = {
  key: 0,
  class: "step",
  style: {"height":"5rem"}
}
const _hoisted_17 = { class: "px-3" }
const _hoisted_18 = { class: "step-label" }
const _hoisted_19 = { class: "step-description" }
const _hoisted_20 = { class: "text-red" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "px-3" }
const _hoisted_23 = { class: "step-label" }
const _hoisted_24 = { class: "step-description" }
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = { class: "px-3" }
const _hoisted_27 = { class: "step-label" }
const _hoisted_28 = { class: "step-description" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = { class: "px-3" }
const _hoisted_31 = { class: "step-label" }
const _hoisted_32 = { class: "step-description" }
const _hoisted_33 = { class: "s9_mobile" }
const _hoisted_34 = { class: "widget s20 px-6 py-7" }
const _hoisted_35 = { class: "s10 secondary-font text-grey-700 mb-4 text-right" }
const _hoisted_36 = { class: "s10 secondary-font text-red mb-4 text-right" }
const _hoisted_37 = { class: "s10 secondary-font text-grey-700 mb-4 text-right" }
const _hoisted_38 = { class: "s10 secondary-font text-grey-700 mb-4 text-right" }
const _hoisted_39 = { class: "s20 flex-center bg-color rounded-20 px-5 pt-4 pb-3" }
const _hoisted_40 = { class: "s10 secondary-font text-primary-color text-right" }
const _hoisted_41 = ["disabled"]

import ConfirmationModal from '@/components/ConfirmationModal.vue';
import { formatAmount, formatDateFrench } from '@/utils/formatters';
import { getMarketMotifRejetLabel } from '@/utils/market';
import axios from 'axios';
import { inject, onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'FrontOfficeCommandesDetails',
  setup(__props) {

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const commande = reactive({
    id: 0,
    num_commande: '',
    created_at: '',
    updated_at: '',
    produits: [] as any[],
    mode_paiement: '',
    statut: '',
    frais_livraison: 0,
    nb_echeance: 0,
    nb_jour_echeance: 0,
    total_echeances: 0,
    total_promotion: 0,
    reste: 0,
    sous_total: 0,
    total: 0,
    adresse_livraison_id: 0,
    type_livraison_id: 0,
    user_id: 0,
    date_livraison_prevue: '',
    date_validation_commande: '',
    date_expedition_commande: '',
    date_livraison_commande: '',
    reception_commande: false,
    date_reception_commande: '',
    motif_rejet_commande: '',
    commentaire_rejet_commande: '',
    adresse_livraison: {
        id: 0,
        adresse: '',
        telephone: '',
    }
});
const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
const loading = ref(false);
const errorMessage = ref('');

onMounted(() => {
    const routeCommande: any = router.currentRoute.value.meta.commande;
    if (routeCommande) {
        routeCommande.produits.forEach((p: any) => {
            p.quantite = parseFloat(p.quantite);
        });
        Object.assign(commande, routeCommande);
    }

});

async function doConfirmReception() {
    const confirmation = await confirmationModalRef.value?.open("Commande Market", "Confirmez-vous la réception de cette commande ?");
    if (confirmation) {
        try {
            loading.value = true;
            errorMessage.value = '';
            const result = await axios.post(`/market/confirm_reception_commande/${commande.id}`, {});
            Object.assign(commande, result.data.commande);
        } catch(error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }
}


return (_ctx: any,_cache: any) => {
  const _component_ng_container = _resolveComponent("ng-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-4" }, " Ma commande ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, "#" + _toDisplayString(commande.num_commande), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commande.produits, (product, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex-center mb-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _unref(BACKEND_URL) + '/assets/market_produits/300/' + product.image,
                    width: "100%"
                  }, null, 8, _hoisted_7)
                ])
              ])
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "s1" }, " ", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", _hoisted_9, [
                _createElementVNode("h6", _hoisted_10, _toDisplayString(product.nom), 1)
              ]),
              _createElementVNode("h5", _hoisted_11, _toDisplayString(product.quantite + ' x ' + _unref(formatAmount)(product.total)) + " F CFA", 1)
            ])
          ]))
        }), 128)),
        _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
        _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "secondary-font text-grey-700 mt-5 mb-5" }, "Livraison prévue", -1)),
        _createElementVNode("h6", _hoisted_12, _toDisplayString(commande.date_livraison_prevue ? _unref(formatDateFrench)(commande.date_livraison_prevue) : 'Date de livraison non précisée'), 1),
        _createElementVNode("h6", _hoisted_13, [
          _createTextVNode(_toDisplayString(commande.adresse_livraison ? commande.adresse_livraison.adresse : 'Adresse de livraison non précisée'), 1),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(commande.adresse_livraison ? commande.adresse_livraison.telephone : 'Téléphone non précisé'), 1)
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass(["step-dot", {'active': commande.statut != 'cancelled', 'danger': commande.statut == 'cancelled'}])
              }, null, 2),
              (commande.statut != 'cancelled')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "step-bg" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(commande.date_validation_commande ? (commande.statut == 'cancelled' ? ('Commande annulée (' + _unref(getMarketMotifRejetLabel)(commande.motif_rejet_commande) + ')') : 'Commande confirmée') : 'Commande en cours de validation'), 1),
              _createElementVNode("p", _hoisted_19, [
                _createTextVNode(_toDisplayString(commande.date_validation_commande ? _unref(formatDateFrench)(commande.date_validation_commande) : '') + " ", 1),
                (commande.commentaire_rejet_commande)
                  ? (_openBlock(), _createBlock(_component_ng_container, { key: 0 }, {
                      default: _withCtx(() => [
                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(commande.commentaire_rejet_commande), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (commande.statut != 'cancelled')
            ? (_openBlock(), _createBlock(_component_ng_container, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["step-dot", { active: commande.date_validation_commande }])
                      }, null, 2),
                      _cache[4] || (_cache[4] = _createElementVNode("div", {
                        class: "step",
                        style: {"height":"5rem"}
                      }, [
                        _createElementVNode("div", { class: "step-bg" })
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(commande.date_expedition_commande ? 'Commande expédiée' : 'Commande en cours de traitement'), 1),
                      _createElementVNode("p", _hoisted_24, _toDisplayString(commande.date_expedition_commande ? _unref(formatDateFrench)(commande.date_expedition_commande) : ''), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["step-dot", { active: commande.date_expedition_commande }])
                      }, null, 2),
                      _cache[5] || (_cache[5] = _createElementVNode("div", {
                        class: "step",
                        style: {"height":"5rem"}
                      }, [
                        _createElementVNode("div", { class: "step-bg" })
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(commande.date_livraison_commande ? 'Commande livrée' : 'Livraison commande'), 1),
                      _createElementVNode("p", _hoisted_28, _toDisplayString(commande.date_livraison_commande ? _unref(formatDateFrench)(commande.date_livraison_commande) : ''), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["step-dot", { active: commande.date_livraison_commande }])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(commande.date_reception_commande ? 'Commande reçue' : 'Réception commande'), 1),
                      _createElementVNode("p", _hoisted_32, _toDisplayString(commande.date_reception_commande ? _unref(formatDateFrench)(commande.date_reception_commande) : ''), 1)
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "s1_mobile" }, " ", -1)),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "secondary-font text-grey-700 mb-5" }, "Votre commande", -1)),
          _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "s10 secondary-font text-grey-700 mb-4" }, "Sous-total", -1)),
          _createElementVNode("h5", _hoisted_35, _toDisplayString(_unref(formatAmount)(commande.sous_total)) + " F", 1),
          _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "s10 secondary-font text-red mb-4" }, "Réduction", -1)),
          _createElementVNode("h5", _hoisted_36, "-" + _toDisplayString(_unref(formatAmount)(commande.total_promotion)) + " F", 1),
          _cache[14] || (_cache[14] = _createElementVNode("h5", { class: "s10 secondary-font text-grey-700 mb-4" }, "Livraison", -1)),
          _createElementVNode("h5", _hoisted_37, _toDisplayString(_unref(formatAmount)(commande.frais_livraison)) + " F", 1),
          _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "s10 secondary-font text-grey-700 mb-4" }, "TOTAL", -1)),
          _createElementVNode("h5", _hoisted_38, _toDisplayString(_unref(formatAmount)(commande.total)) + " F", 1),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
          _createElementVNode("div", _hoisted_39, [
            _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "s10 secondary-font text-primary-color" }, "Payer par mois", -1)),
            _createElementVNode("h5", _hoisted_40, _toDisplayString(_unref(formatAmount)(commande.total_echeances)) + " F", 1)
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          (commande.statut == 'shipped')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-ultra lg w-100",
                onClick: doConfirmReception,
                disabled: loading.value
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("div", { class: "btn-show" }, [
                  _createElementVNode("span", null, " J'ai reçu ma commande")
                ], -1),
                _createElementVNode("div", { class: "btn-loading" }, [
                  _createElementVNode("div", { class: "loader-dots" })
                ], -1)
              ]))], 8, _hoisted_41))
            : _createCommentVNode("", true)
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "clear-both h-25" }, null, -1))
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
    ]),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ], 64))
}
}

})